import { Types } from 'mongoose';
import { IAccountOwned } from './account';

export interface ITask extends IAccountOwned {
  _id: Types.ObjectId;
  type: string;
  subtype: string;
  payload: any;
  status: TaskStatus;
  notes: string;
  created_on: Date;
  watermark: string;
  progress: number;
}

export interface ITaskStage {
  i: number;
  name: string;
  status: 'running' | 'complete' | 'error' | 'pending';
  progress: number;
}

export interface IUnpackingTaskPayload {
  totalFiles?: number;
  totalAlbums?: number;
  stages: {
    download: ITaskStage;
    extract: ITaskStage;
    albums: ITaskStage;
    thumbnails: ITaskStage;
    uploadRaws: ITaskStage;
    uploadThumbnails: ITaskStage;
    dbImages: ITaskStage;
    cleaningUp: ITaskStage;
  };
}

export enum TaskStatus {
  Pending = 'pending',
  Error = 'error',
  Working = 'working',
  Complete = 'complete',
}
